<template>
  <div class="container" v-if="diet.id">
    <h1>
      <EditableCellInput 
        v-model="diet.name" 
        class="main-title"
        :state="$v.diet.name.$invalid ? false : null "
      />
    </h1>
    <ProgramIndications
      v-model="diet.indications"
      :presets="indicationPresets"
      class="indications-container"
    />
    <transition-group name="meals">
      <PlanMeal 
        v-for="(meal,index) in diet.meals" 
        :key="'meal-' + meal.id"
        v-model="diet.meals[index]"
        :index="index" 
        :example-presets="examplePresets"
        @remove="removeMeal"
        @changed-time="orderMeals"
      />
    </transition-group>
  </div>
</template>

<script>
import EditableCellInput from "../EditableCellInput";
import PlanMeal from "./PlanMeal"
import ProgramIndications from "../ProgramIndications";
import { mapState } from "vuex";
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'DietPlan',
  components: {
    EditableCellInput,
    PlanMeal,
    ProgramIndications
  },
  model: {
    prop: "dietData",
    event: "change",
  },
  props: {
    dietData: {
      type: Object,
      default: function () { return { name: undefined } },
    },
    indicationPresets: {
      type: Array,
      default: function () { return [{ name: "Vacio" , text: ""}] },
    },
    examplePresets: {
      type: Array,
      default: function () { return [{ name: "Vacio" , text: ""}] },
    }
  },
  data: function() {
    return {
      diet: this.dietData
    };
  },
  validations: {
    diet: {
      name: {
        maxLength: maxLength(100)
      }
    }
  },
  computed: {
    ...mapState(["login"])
  },
  methods: {
    removeMeal: function (mealIndex) {
      this.$emit("remove-meal", mealIndex)
    },
    orderMeals: function () {
      let meals = this.diet.meals
      meals.sort((a,b)=>{return this.timeComparator(a.start_time, b.start_time)})
    },
    timeComparator: function (a, b) {
      let momentA = this.$moment(a, ["HH:mm", "HH:mm:ss"])
      let momentB = this.$moment(b, ["HH:mm", "HH:mm:ss"])
      if (momentA.isBefore(momentB)) {
        return -1
      } else if (momentA.isAfter(momentB)) {
        return 1
      } else {
        return 0
      }
    }
  },
  watch: {
    diet: function(val) {
      this.$emit("change", val)
    }
  }
};
</script>

<style scoped lang="scss">
.main-title {
  font-size: $h1-font-size;
  font-weight: bold;
  color: $body-color;
  margin: 2rem 0;
  text-align: center;
}
.indications-container {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid $gray-500;
  border-radius: 10px;
  padding: 0 map_get($spacers, 4) map_get($spacers, 4);
  margin: $spacer 0 $spacer * 3;
}
.bd-sidebar {
  border-right: 1px solid #eee;
}
.bd-toc {
  border-left: 1px solid #eee;
}
.no-hover-info {
  border-color: #17a2b8;
  color: #17a2b8;
}
.no-hover-info:hover {
  border-color: #17a2b8;
  color: #17a2b8;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-disabled {
  cursor: not-allowed;
}
.no-login {
  border-radius: 0.3rem;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgb(23, 162, 184);
  text-align: center;
}
.no-login-content {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.border-green {
  border: 1px solid rgba(23, 162, 184, 0.33);
}
.meals-enter-active,
.meals-leave-active {
  transition: opacity 0.5s ease-in;
}

.meals-enter,
.meals-leave-to {
  opacity: 0;
}

.meals-move {
  transition: transform 1s;
}
</style>